import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const Authenticated = () => {
  const isLoggedIn = useSelector((state) => state?.userAuth?.isLoggedIn);
  return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
};

export default Authenticated;
